import Dialog from 'components/overlays/Dialog';
import './_styles.scss';

import Button from 'components/actions/Button';
import { SubGridCard } from 'components/content/SubGridCard';
import { useDispatch, useSelector } from 'react-redux';
import { getShowRoleDialog, toogleShowRoleDialog } from 'store/slices/settingsPageSlice';

interface RoleInfodialogProps {
    isLoading: boolean;
    isError: boolean;
}

const RoleInfodialog = ({ isLoading }: RoleInfodialogProps) => {
    const dispatch = useDispatch();
    const showRoleDialog = useSelector(getShowRoleDialog);
    const showCloseButton = true;
    const toogleSiderBarAction = () => {
        dispatch(toogleShowRoleDialog());
    };
    return (
        <Dialog
            showCloseButton={showCloseButton}
            data-testid='request-exception-dialog'
            bodyClassName='RoleInfoDialog'
            show={showRoleDialog}
            title={<p className='RoleInfoDialog__title'>User roles on the Control Center</p>}
            footer={
                <Button style='primary' onClick={toogleSiderBarAction}>
                    Close
                </Button>
            }
            body={
                <div className='RoleInfoDialog__bodyContent'>
                    <p className='RoleInfoDialog__bodyText'>
                        Roles are predefined access permissions for users. The system admin is the responsible to manage
                        users and assing one or more roles to them (e.g user can be a lead technical supervisor and a
                        system admin at the same time).
                    </p>
                    <br />
                    <p className='RoleInfoDialog__bodyText'>The platform has the following user roles:</p>
                    <div className='display-grid grid-cols-1-xs grid-cols-4-1fr-max-content margin-y-25 gap-15'>
                        <SubGridCard
                            icon={<span className='rioglyph rioglyph-user mr-5 text-20' aria-hidden='true' />}
                            title={'Technical Supervisor'}
                            content={
                                <ol className='RoleInfoDialog__styledList'>
                                    <li>
                                        Can only see and perform actions on vehicles in their team&apos;s assigned fleet
                                    </li>
                                    <li>Cannot see other vehicles and fleets</li>
                                    <li>Cannot manage users, teams or fleets</li>
                                </ol>
                            }
                        />
                        <SubGridCard
                            icon={<span className='rioglyph rioglyph-workshop mr-5 text-20' aria-hidden='true' />}
                            title={'System admin'}
                            content={
                                <ol className='RoleInfoDialog__styledList'>
                                    <li>Can see all vehicles and fleets</li>
                                    <li>Can manage users, teams and fleets</li>
                                    <li>Cannot perform any actions on vehicles</li>
                                </ol>
                            }
                        />
                        <SubGridCard
                            icon={<span className='rioglyph rioglyph-eye-option mr-5 text-20' aria-hidden='true' />}
                            title={'Read only'}
                            content={
                                <ol className='RoleInfoDialog__styledList'>
                                    <li>Can only see vehicles in their team&apos;s assigned fleet</li>
                                    <li>Cannot perform any actions in platform</li>
                                </ol>
                            }
                        />
                    </div>
                </div>
            }
            onClose={toogleSiderBarAction}
            disableEsc={isLoading}
            size='md'
        />
    );
};

export default RoleInfodialog;
